import { PortalProformas } from "@/features/portal/components/portal-proformas";

/** `/portal/proposals` — approved proforma proposals for the client. */
export default function ProposalsPage() {
  return <PortalProformas />;
}
